import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import {
  getLoyaltyBenefitModalPath,
  LOYALTY_EXCLUSIVE_SAVINGS_HASH,
} from 'loyalty/constants/loyaltyRoutes'

interface Props {
  layout: 'tile' | 'row'
}

function LandingPageLoyaltyExclusiveSavings(props: Props) {
  const { layout } = props
  const intl = useIntl()

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="family_and_friends_access"
    heading={intl.formatMessage({
      id: 'pezwI9oyKQUq8WKmMrmj',
      defaultMessage: 'Access to exclusive savings',
      description: 'Heading for the Infinite member benefit tile granting access to exclusive savings and offers',
    })}
    subtitle={<BodyText variant="small">{intl.formatMessage({
      id: '4USqW09Gx5p1PPMzZDEL',
      defaultMessage: 'Including our direct Maldives charter flights, with priority upgrades',
      description: 'Subtitle for the Infinite exclusive savings benefit tile describing direct Maldives charter flight access',
    })}
    </BodyText>}
    to={getLoyaltyBenefitModalPath(LOYALTY_EXCLUSIVE_SAVINGS_HASH)}
  />
}

export default LandingPageLoyaltyExclusiveSavings
